import {
  BackgroundColors,
  PositiveColors,
  PrimaryColors,
} from '@picsart/design-system/foundation/colors';

import { createUseStyles } from 'react-jss';

import { mediaQuery } from '@picsart/rc/helpers';
import { BorderRadiuses, BreakPoints, CenterAlignedContentWidth } from '@picsart/rc/enums';
import { FontSizes, FontWeights } from '@picsart/rc/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  {
    root: {
      width: '100%',
      margin: '0 auto',

      [mediaQuery(BreakPoints.ExtraLarge)]: {
        maxWidth: `${CenterAlignedContentWidth.Adaptive}`,
      },
      [mediaQuery(BreakPoints.Large)]: {
        padding: 0,
      },
    },
    informationInnerHolder: {
      padding: '36px',
      borderRadius: BorderRadiuses.Size_4,
      border: '1px solid #EDEEF4',
      backgroundColor: BackgroundColors.tint2,

      [mediaQuery(BreakPoints.Large)]: {
        padding: [50, 36, 56, 36],
        borderRadius: 0,
      },
      [mediaQuery(BreakPoints.Medium)]: {
        padding: [Spacings.s24, Spacings.s24, 36, Spacings.s24],
      },
    },
    informationTitle: {
      fontWeight: FontWeights.SemiBold,
      fontSize: FontSizes.Size_10,
      color: PositiveColors.text.default,
    },
    informationItemHolder: {
      marginTop: Spacings.s24,
      marginBottom: Spacings.s24,
      '&:last-child': {
        marginBottom: 0,
      },
    },
    informationItemTitle: {
      fontWeight: FontWeights.SemiBold,
      fontSize: FontSizes.Size_16,
      color: '#5F606D',

      [mediaQuery(BreakPoints.Small)]: {
        fontSize: FontSizes.Size_6,
      },
    },
    informationItemText: {
      marginTop: Spacings.s12,
      fontWeight: FontWeights.Medium,
      fontSize: FontSizes.Size_5,
      color: '#4C4C4C',

      '& a': {
        color: PrimaryColors.base.default,
      },

      [mediaQuery(BreakPoints.Small)]: {
        marginTop: Spacings.s8,
      },
    },
  },
  {
    name: 'categories-bottom-info',
  },
);

export default useStyles;
